import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";

import CardComponent from "./CardComponent";
const CardSection = () => {
    const link = ['']

    return (
            <div className="container" id="prezzi">
                < div className="row gx-4 gy-4 my-5 justify-content-center">
                        <CardComponent title={'Pacchetto 10 minuti'} price={'2,00'} name={'BASIC'} minutes={'10'} onBuy={''} index={0}/>
                        <CardComponent title={'Pacchetto 30 minuti'} price={'6,00'} name={'STANDARD'} minutes={'30'} onBuy={''} index={1}/>
                        <CardComponent title={'Pacchetto 60 minuti'} price={'10,00'} name={'PRO'} minutes={'60'} onBuy={''} index={2}/>
                </div>
            </div>
    );

};

export default CardSection;
